/* eslint-disable sort-keys-fix/sort-keys-fix */
export const HeapUserProperties = {
    EMAIL: 'SaaS Email',
    ID: 'SaaS ID',
    FIRST_NAME: 'SaaS First Name',
    LAST_NAME: 'SaaS Last Name',
    AUVIK_DOMAIN: 'SaaS Auvik Domain',
    PERMISSION_ID: 'SaaS Permission Id',
    PERMISSION_NAME: 'SaaS Permission Name',
    TENANT_CREATION_DATE: 'Saas Tenant Creation Date',
    TENANT_TRIAL: 'SaaS Tenant Trial',
    TENANT_IDENTITY_ID: 'SaaS Tenant Identity Id',
    TENANT_IDENTITY_NAME: 'SaaS Tenant Identity Name',
    TENANT_IDENTITY_TYPE: 'SaaS Tenant Identity Type',
    TENANT_NAME: 'SaaS Tenant Name',
    TENANT_REGION: 'SaaS Tenant Region',
    TENANT_ANM: 'SaaS Tenant ANM',
    HUB_TYPE: 'SaaS Hub Type',
    LICENSE_HUB: 'SaaS Licensed Hub',
    IN_TRIAL: 'SaaS In Trial',
    EXPIRED_TRIAL: 'SaaS Expired Trial'
};

// Pendo does not allow spaces in keys
export const PendoUserProperties = {
    EMAIL: 'SaasEmail',
    ID: 'SaasID',
    FIRST_NAME: 'SaasFirstName',
    LAST_NAME: 'SaasLastName',
    AUVIK_DOMAIN: 'SaasAuvikDomain',
    PERMISSION_ID: 'SaasPermissionId',
    PERMISSION_NAME: 'SaasPermissionName',
    TENANT_CREATION_DATE: 'SaasTenantCreationDate',
    TENANT_TRIAL: 'SaasTenantTrial',
    TENANT_IDENTITY_ID: 'SaasTenantIdentityId',
    TENANT_IDENTITY_NAME: 'SaasTenantIdentityName',
    TENANT_IDENTITY_TYPE: 'SaasTenantIdentityType',
    TENANT_NAME: 'SaasTenantName',
    TENANT_REGION: 'SaasTenantRegion',
    TENANT_ANM: 'SaasTenantANM',
    HUB_TYPE: 'SaasHubType',
    LICENSE_HUB: 'SaasLicensedHub',
    IN_TRIAL: 'SaasInTrial',
    EXPIRED_TRIAL: 'SaasExpiredTrial'
};
